/*eslint-disable*/
import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Steps, Typography, Icon, message } from "antd";
import { platformApi } from "../../../../api";
import WrappedFinancierDataForm from "./FinancierDataForm";
import WrappedFinancierContactsForm from "./FinancierContacts";

const { Step } = Steps;
const { Text } = Typography;

const FinancierForm = ({
  open,
  close,
  values,
  editable,
  refreshData
}) => {
  const ChildRef = useRef();
  const ClearRef = useRef();

  const [current, setCurrent] = useState(0);
  const [data, setData] = useState({});
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [logo, setLogo] = useState(null);
  
  const steps = [
    { id: 1, title: "Financier Data", icon: "home" },
    { id: 2, title: "Financier Contact", icon: "contacts" },
  ];

  useEffect(() => {
    if (values) {
      setData(values);
    } else {
      setData({});
    }
  }, [values]);

  const clearFields = () => {
    setData({});
    setCurrent(0);
    if (ClearRef.current) ClearRef.current();
    close();
    refreshData();
  };

  const handleSubmit = () => {
    setConfirmLoading(true);

    const payload = { ...data };

    if (payload.address) {
      if (payload.address.country) payload.address.country = payload.address.country.id || payload.address.country;
      if (payload.address.state) payload.address.state = payload.address.state.id || payload.address.state;
      if (payload.address.district) payload.address.district = payload.address.district.id || payload.address.district;
    }
    payload.logo=logo;

    if (!values || !values.id) {
      platformApi
        .post("/api/financer/", payload)
        .then((res) => {
          const { data } = res;
          if (data.code === 200 && data.response.code === 200) {
            message.success("Financier added successfully");
            clearFields();
          } else {
            message.error("Failed to create Financier");
          }
        })
        .catch((err) => {
          console.error("Financier create error:", err);
          message.error("Connection error");
        })
        .finally(() => setConfirmLoading(false));
    } else {
      payload.id = values.id;
      platformApi
        .put(`/api/financer/${values.id}`, payload)
        .then((res) => {
          const { data } = res;
          if (data.code === 200 && data.response.code === 200) {
            message.success("Financier updated successfully");
            clearFields();
          } else {
            message.error("Failed to update Financier");
          }
        })
        .catch((err) => {
          console.error("Financier update error:", err);
          message.error("Connection error");
        })
        .finally(() => setConfirmLoading(false));
    }
  };

  return (
    <Modal
      width="60%"
      confirmLoading={confirmLoading}
      title="Financier Master"
      visible={open}
      onCancel={() => clearFields()}
     footer={[
           <Button
             onClick={() => {
               current > 0 ? setCurrent(current - 1) : clearFields();
             }}
             key={2}
           >
             {current > 0 ? "Previous" : "Cancel"}
           </Button>,   
           <Button
           key={3}
             onClick={() => {
               if (ChildRef.current()) {
                 if (current < steps.length - 1) { 
                   setCurrent(current + 1);
                 } else {
                   editable ?  handleSubmit() : clearFields() ;
                 }
               }
             }}
             type="primary"
           >
             {current < steps.length - 1 
               ? "Next" 
               : (editable ? "Save" : "Cancel")}
           </Button>
         ]}
    >
      <Steps size="small" type="navigation" current={current}>
        {steps.map((step) => (
          <Step
            key={step.id}
            icon={<Icon type={step.icon} />}
            title={<Text>{step.title}</Text>}
          />
        ))}
      </Steps>
      <div style={{ marginTop: "1.5rem" }}>
        {current === 0 && (
          <WrappedFinancierDataForm
            data={data}
            setData={setData}
            editable={editable}
            validityRef={ChildRef}
            clearRef={ClearRef}
            logo={logo}
            setLogo={setLogo}
          />
        )}
        {current === 1 && (
          <WrappedFinancierContactsForm
            data={data}
            setData={setData}
            editable={editable}
            validityRef={ChildRef}
            clearRef={ClearRef}
          />
        )}
      </div>
    </Modal>
  );
};

export default FinancierForm;